import React, { useEffect } from 'react'
import styled from 'styled-components'
import { 
  // NavLink,
  Outlet,
  // useLocation,
  // useNavigate 
} from 'react-router-dom'
import { SafeImg } from '../../components/SafeImgs'
// const CONTROL_PANEL_PATH_ROOT = '/controlpanel'


// import { useStore } from '../../zustandStore'
// import { shallow } from 'zustand/shallow'

function CtrlPanelNavBar(props) {

  // const event = useStore(state => state.event, shallow)
  // const players = useStore(state => state.players, shallow)
  // const obsState = useStore(state => state.obsState, shallow)

  // const { search } = useLocation()
  // const navigate = useNavigate()

  // const NavLinkWithQuery = (props) => {
  //   // const searchWithoutSort = '?' + search.replace(/^\?/, '').replace(/sortby=[\w\d]+\&?/g,'').replace(/\&$/, '')

  //   return <NavLink {...props} to={props.to + search}/>
  // }

  useEffect(() => {
    document.title = "Comms tools: " + document.title
  }, [])

  return <>
    <NavbarLogoWrapper>
      <StlyedLogoWrapper>
        <SafeImg src={'/images/logos/ctt_sj.png'} />
      </StlyedLogoWrapper>
      <StyledEventName>
        Control Panel
      </StyledEventName>
    </NavbarLogoWrapper>
    <Outlet />
  </>
}

export default CtrlPanelNavBar

const NavbarLogoWrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  padding-top: min(5vw, 15px);
  margin-bottom: min(8.3vw, 25px);
`

const StyledEventName = styled.div`
  font-size: min(7vw, 30px);
  margin-bottom: 0.5em;
`

const StlyedLogoWrapper = styled.div`
  text-align: center;
  > img {
    max-width: 100px;
    width: 80vw;
  }
`

const StlyedLinksWrapper = styled.div`
  display: flex;
  justify-content: space-around;
  width: 95vw;
  max-width: 450px;

  --nav-link-default-color: rgb(91, 81, 135);
  --nav-link-hover-color: rgb(134, 122, 184);
  --nav-link-active-border-color: lightblue;

  a {
    display: flex;
    justify-content: center;
    flex-direction: column;

    font-size: min(7vw, 24px);
    color: #ddd;
    text-decoration: none;
    text-align: center;
    background-color: var(--nav-link-default-color);

    height: 3em;
    max-width: 7.4em;
    width: 7.4em;
    padding-top: 0.2em;
    padding-bottom: 0.2em;
    border-radius: min(4px, 1.2vw);

    &.tab-active {
      pointer-events: none;
      border: 2px solid var(--nav-link-active-border-color);
    }
    &:not(.tab-active){
      &:hover {
        border: 2px solid var(--nav-link-hover-color);
        background-color: var(--nav-link-hover-color);
      }
      &:not(:hover) {
        border: 2px solid var(--nav-link-default-color);
      }
    }
  }
`

